import {KennethMustDie} from "../KennethMustDie";
import {KMD_SYMBOL_ANIMATIONS} from "../server/IKMDData";
import {gsap} from "gsap";
import {KMDGameMode} from "../server/KMDGameMode";
import {KMDSound} from "../sound/KMDSound";

export class KMDStickyS2 extends PIXI.Container {

    private readonly _s2: PIXI.spine.Spine;
    private readonly _lock: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "KMDStickyS2";

        this._s2 = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("S2"));
        this._s2.visible = false;

        this._lock = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("locks"));
        this._lock.visible = false;

        this.x = 648;

        this.addChild(this._s2, this._lock);
    }

    public showStickyS2(y: number): void {
        this._s2.y = y;
        this._s2.visible = true;
        this._s2.updateTransform();
        this._s2.state.setAnimation(0, KMD_SYMBOL_ANIMATIONS.NORMAL, false);

        this.showLock(y);
    }

    public hideStickyS2(): void {
        this._s2.visible = false;
        this._s2.state.clearTracks();
    }

    public showLock(y: number): void {
        const mode: string = KennethMustDie.model.data.mode,
            nextMode: string = KennethMustDie.model.data.nextMode;

        // no lock on S2 during normal/FS or normal_avalanche/FS_avalanche in mode/nextMode
        if ((mode.indexOf("NORMAL") > -1 && nextMode.indexOf("NORMAL") > -1) || ((mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE) && (nextMode !== KMDGameMode.FREESPIN_COOL && nextMode !== KMDGameMode.FREESPIN_SUPER))) {
            return;
        }

        if (!this._lock.visible) {
            this._lock.y = y;
            this._lock.visible = true;
            this._lock.updateTransform();

            KennethMustDie.createTimelineForAnimation(this._lock, 0, "locked_150_start", false).eventCallback("onComplete", () => {
                this._lock.autoUpdate = true;

                this._lock.state.setAnimation(0, "locked_150", true);
            });
        }
    }

    public hideLock(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (this._lock.visible) {
            this._lock.state.clearTracks();

            // #480
            KennethMustDie.soundPlayer.playSound(KMDSound.CHAINED_UNLOCKED);

            tl.add(KennethMustDie.createTimelineForAnimation(this._lock, 0, "locked_150_disappear", false).eventCallback("onComplete", () => {
                this._lock.visible = false;
            }));
        }

        return tl;
    }
}